/*
 *
 *  remotes
 *
 */

import api from "../../helpers";

/**
 *
 * @param {string} metaData
 * @returns
 */

export async function loadLeaveDetailsAPI(searchFilter) {
  return await api
    .post(`/auth/getleaverequest`, searchFilter)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadPermissionDetailsAPI(searchFilter) {
  return await api
    .post(`/auth/getpermissionreq`, searchFilter)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadLOPDetails(searchFilter) {
  return await api
    .post(`/auth/employee/getlop`, searchFilter)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function loadSettingDetails(searchFilter) {
  return await api
    .post(`/protected/getlopsetting`, searchFilter)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}


export async function loadLeaveDropdownAPI(metaData, method, leave) {
  if (leave) {
    return await api
      .post(`/auth/employee/get${metaData}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error));
  } else if(method ==="post") {
    return await api
      .post(`/protected/get${metaData}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  }

}

const remotes = {
  loadLeaveDetailsAPI,
  loadPermissionDetailsAPI,
  loadLOPDetails,
  loadLeaveDropdownAPI,
  loadSettingDetails
};

export default remotes;
